import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcWriteMoveArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.74958 13.625L11.5156 8.49963L5.74958 3.37425",
		stroke: "#868E96",
		strokeWidth: 1.15321,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcWriteMoveArrow;
